import { EMAIL_TEMPLATE_CONSTANTS } from '@/constants/emailTemplateConstants'

const initialState = {
  // Templates data
  templates: [],
  loading: false,
  error: null,

  // Create template
  createLoading: false,
  createError: null,
  createSuccess: false,

  // Update template
  updateLoading: false,
  updateError: null,
  updateSuccess: false,

  // Delete template
  deleteLoading: false,
  deleteError: null,
  deleteSuccess: false
}

export const emailTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch templates
    case EMAIL_TEMPLATE_CONSTANTS.FETCH_EMAIL_TEMPLATES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case EMAIL_TEMPLATE_CONSTANTS.FETCH_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        templates: action.payload
      }
    case EMAIL_TEMPLATE_CONSTANTS.FETCH_EMAIL_TEMPLATES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        templates: []
      }

    // Create template
    case EMAIL_TEMPLATE_CONSTANTS.CREATE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        createLoading: true,
        createError: null,
        createSuccess: false
      }
    case EMAIL_TEMPLATE_CONSTANTS.CREATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        createError: null,
        createSuccess: true,
        templates: [...state.templates, action.payload]
      }
    case EMAIL_TEMPLATE_CONSTANTS.CREATE_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        createLoading: false,
        createError: action.payload,
        createSuccess: false
      }

    // Update template
    case EMAIL_TEMPLATE_CONSTANTS.UPDATE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: null,
        updateSuccess: false
      }
    case EMAIL_TEMPLATE_CONSTANTS.UPDATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateError: null,
        updateSuccess: true,
        templates: state.templates.map((template) => (template.id === action.payload.id ? action.payload : template))
      }
    case EMAIL_TEMPLATE_CONSTANTS.UPDATE_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload,
        updateSuccess: false
      }

    // Delete template
    case EMAIL_TEMPLATE_CONSTANTS.DELETE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        deleteError: null,
        deleteSuccess: false
      }
    case EMAIL_TEMPLATE_CONSTANTS.DELETE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteError: null,
        deleteSuccess: true,
        templates: state.templates.filter((template) => template.id !== action.payload)
      }
    case EMAIL_TEMPLATE_CONSTANTS.DELETE_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.payload,
        deleteSuccess: false
      }

    // Reset success states
    case EMAIL_TEMPLATE_CONSTANTS.RESET_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        createSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        createError: null,
        updateError: null,
        deleteError: null
      }

    // Reset entire state
    case EMAIL_TEMPLATE_CONSTANTS.RESET_EMAIL_TEMPLATES:
      return initialState

    default:
      return state
  }
}
